<template>
  <v-app>
    <!-- <v-system-bar
      color="rgba(36, 40, 51, 0.62)"
      absolute
      :height="22"
      :style="{width: navWidth(false), clipPath:'polygon( 0 0, 100% 0, 100% 0, 100% 0, calc(100% - 22px) 100%, 100% 100%, 0 100%, 0 22px )'}"
    >
      <span class="inner-container">滚动字幕滚动字幕滚动字幕滚动字幕</span>
    </v-system-bar>-->
    <v-system-bar
      color="rgba(24, 25, 27, 0.8)"
      absolute
      :height="22"
      :style="{}"
    >
      <span class="inner-container">
        <div style="white-space: nowrap; font-size: 13px">{{ systemBar }}</div>
      </span>
    </v-system-bar>
    <v-app-bar
      flat
      absolute
      :extended="false"
      height="40"
      color="rgba(218, 8, 8, 0.67)"
      dark
      :style="{ width: navWidth(true), top: '22px' }"
    >
      <v-toolbar-title style="font-weight: 600; letter-spacing: 3px"
        >川剧艺术传播博物馆</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-items v-show="fullwidth" style="margin-right: -5px">
        <v-btn
          text
          v-for="(nav, index) in navs"
          :key="index"
          style="font-weight: 600; padding: 0 12px"
          @click="navHandle(nav)"
          >{{ nav.title }}</v-btn
        >
      </v-toolbar-items>
      <v-app-bar-nav-icon v-show="!fullwidth" style="margin-right: -5px">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon color="white" v-on="on">
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(nav, i) in navs"
              :key="i"
              @click="navHandle(nav)"
            >
              <v-list-item-title>{{ nav.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar-nav-icon>
      <div
        id="jiao"
        style="
          width: 0px;
          height: 0px;
          border-right: 40px solid transparent;
          border-top: 40px solid rgba(218, 8, 8, 0.67);
          border-bottom: 0px solid transparent;
          position: absolute;
          top: 0;
          right: -40px;
          z-index: 900;
        "
      ></div>
    </v-app-bar>
    <v-dialog v-model="dialog" width="720px">
      <component
        :is="navData.component + '-card'"
        :nav="curNav"
        :navData="navData"
        @close="dialog = false"
      ></component>
    </v-dialog>
    <v-dialog v-model="dialog2" width="720px">
      <article-card
        v-if="navData2"
        :navData="navData2"
        @close="dialog2 = false"
      ></article-card>
      <v-btn
        color="red darken-1"
        large
        dark
        @click="dialog2 = false"
        style="font-size: 16px"
        >开 始</v-btn
      >
    </v-dialog>
    <v-content>
      <iframe
        v-if="!dialog2"
        id="miframe"
        class="miframe"
        src="https://720yun.com/t/cevkiwfbr7h"
        frameborder="no"
        style="width: 100%; height: 100%; padding-top: 22px"
      ></iframe>
    </v-content>
    <div style="font-size: 12px">
      成都不云文化传播有限公司版权所有版权所有©2019-2025 蜀ICP备19037354号
      <a href="https://beian.miit.gov.cn" target="_blank">
        工业和信息化部备案管理系统网站
      </a>
    </div>
  </v-app>
</template>

<script>
import { getNav } from "@/api/info";
import ArticleCard from "@/components/nav/ArticleCard.vue";
import SuggestCard from "@/components/nav/SuggestCard.vue";

export default {
  name: "App",
  components: { ArticleCard, SuggestCard },
  data: () => ({
    systemBar: "",
    dialog: false,
    dialog2: true,
    navData: { component: "article" },
    navData2: undefined, //{ component: "article" },
    curNav: null,
    collapseOnScroll: true,
    navs: [],
    backgroundIndex: 0,
    article: { data: {} },
    items: []
  }),
  computed: {
    fullwidth () {
      let w = document.documentElement.offsetWidth || document.body.offsetWidth;
      return w > 768;
    }
  },
  methods: {
    navWidth (calc = false) {
      if (this.fullwidth) {
        if (calc) {
          return "calc(51% - 22px)";
        } else {
          return "51%";
        }
      } else {
        if (calc) {
          return "calc(76% - 22px)";
        } else {
          return "76%";
        }
        // this.navWidth = "calc(81% - 22px)";
        // this.navTopWidth = "81%";
      }
    },
    navHandle (nav) {
      switch (nav.target) {
        case "blank":
          window.open(nav.url);

          break;
        case "self":
          window.location = nav.url;

          break;
        case "modal":
          this.navData = JSON.parse(nav.data);
          this.curNav = nav;
          this.dialog = true;
          break;
      }
    }
  },
  mounted () {
    // setTimeout(() => {
    //   let loading = document.getElementById("loading");
    //   if (loading != null) {
    //     document.body.removeChild(loading);
    //   }
    // }, 5500);
    getNav("article").then(res => {
      this.dialog2 = true;

      let data = res.data.items[0].data;
      console.log("data", data);
      this.navData2 = JSON.parse(data);
    });

    getNav("top_nav").then(res => {
      this.navs = res.data.items;
    });
    getNav("system_bar").then(res => {
      this.systemBar = res.data.items[0].title;
    });
  }
};
</script>
<style lang="scss">
@import "@/styles/index.scss";
.inner-container {
  color: #fff;
  text-align: right;
  width: 130%;
  position: fixed;
  right: 0;
  animation: myMove 15s linear infinite;
  animation-fill-mode: forwards;
}
/*文字无缝滚动*/
@keyframes myMove {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-90%);
  }
}

.m-iframe {
  .Logo_logo1_3LdbUK {
    display: none !important;
  }
}

.v-application a {
  color: unset;
}

.foot-block {
  text-align: left;
  .foot-title {
    margin-bottom: 24px;
    margin-top: 24px;
  }
  .foot-block-text {
    color: rgba(255, 255, 255, 0.54);
    font-size: 14px;
    text-align: left;
  }
}

.logo {
  margin-left: 20px;
}

.bar-item {
  font-size: 16px !important;
  font-weight: bolder !important;
  line-height: 36px;
}
</style>
